export default {
  computed: {
    allowPoPayment () {
      return this.$store.state?.header?.headerData?.poPayment ?? false
    }
  }
}
